import { html } from "lit-html";
import { panelResize } from "./panel-resize";

const eventsNav = ({onToggle, onResize}) => html`
  <fieldset class="panel-selector">
    <p>Policy Events</p>
    <!--<label for="mode-countries"><input @change=${onToggle} name="mode" id="mode-countries" type="radio" checked>By Country</label>-->
    <!--<label for="mode-states"><input @change=${onToggle} name="mode" id="mode-states" type="radio">By State</label>-->
  </fieldset>
  ${panelResize(onResize)}
`;

export {
  eventsNav
}
